export default "__VITE_ASSET__DVD9H4al__"